import styled from 'styled-components';

export const BlogPostContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid red;
`

export const Title = styled.h1`
font-family: 'Roboto slab' serif;
`

export const Author = styled.h2`

`

export const Date = styled.h3`

`
export const Category = styled.h3`

`

export const Content = styled.p`

`